
const strings = {
  SEARCH_PLACEHOLDER: "Search PO or GRN",
};

export default strings;
